<template>
    <div 
        class="folder-block"
        @click.stop="openGroup(folder.id)"
        :class="[
        { bright: $store.state.system_settings.color_palette == 0 },
        { medium: $store.state.system_settings.color_palette == 1 },
        { blank: $store.state.system_settings.color_palette == 2 },
        { 'colors-open': activeOptionMenu == folder.id && colorExpanded },
        ]"
        :key="'index-'+folder.id"
        :id="folder.id"
    >
        <svg width="328" height="328" viewBox="0 0 328 328" fill="none" xmlns="http://www.w3.org/2000/svg">
             <image
                v-if="folder['data'] && folder['data']['image']"
                :href="getFileUrl(folder['data']['image'])"
                width="328"
                height="328"
                preserveAspectRatio="xMidYMid slice"
                clip-path="url(#cardClip)"
                />
            <path d="M278.494 77.2383C278.481 72.9763 278.421 70.4318 278.13 68.2214C275.589 48.9258 260.406 33.7422 241.11 31.2019C238.316 30.834 234.988 30.834 228.331 30.834H134.992C136.654 32.3234 138.525 34.1944 141.611 37.2804L149.497 45.1673C161.19 56.8601 167.037 62.7066 174.038 66.6017C177.884 68.7415 181.963 70.4313 186.196 71.6378C193.901 73.834 202.169 73.834 218.705 73.834H224.061C249.56 73.834 266.443 73.834 278.494 77.2383Z" fill="#AD9AFF" fill-opacity="0.35"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M167.414 131.168C167.414 125.231 172.227 120.418 178.164 120.418H249.831C255.768 120.418 260.581 125.231 260.581 131.168C260.581 137.105 255.768 141.918 249.831 141.918H178.164C172.227 141.918 167.414 137.105 167.414 131.168Z" fill="#AD9AFF" fill-opacity="0.35"/>
            <clipPath id="cardClip">
                <path fill="url(#paint0_linear_11724_5399)" d="M20.5 87.4464C20.5 74.7968 20.5 68.472 21.494 63.2035C25.8698 40.0111 44.0111 21.8698 67.2035 17.494C72.472 16.5 78.7968 16.5 91.4464 16.5C96.9888 16.5 99.7599 16.5 102.423 16.749C113.905 17.8228 124.797 22.3342 133.675 29.694C135.734 31.4011 137.694 33.3607 141.613 37.2797L149.5 45.1667C161.193 56.8595 167.039 62.7059 174.04 66.6011C177.886 68.7409 181.966 70.4307 186.198 71.6371C193.903 73.8333 202.171 73.8333 218.707 73.8333H224.063C261.794 73.8333 280.659 73.8333 292.922 84.8623C294.05 85.8768 295.123 86.9503 296.138 88.0782C307.167 100.341 307.167 119.206 307.167 156.937V188.5C307.167 242.554 307.167 269.582 290.374 286.374C273.582 303.167 246.554 303.167 192.5 303.167H135.167C81.1123 303.167 54.0851 303.167 37.2925 286.374C20.5 269.582 20.5 242.554 20.5 188.5V87.4464Z"  fill-opacity="0.8" shape-rendering="crispEdges"/>
            </clipPath>
            <g opacity="0.5" filter="url(#filter0_d_11724_5399)">
            <path fill="url(#paint0_linear_11724_5399)" d="M20.5 87.4464C20.5 74.7968 20.5 68.472 21.494 63.2035C25.8698 40.0111 44.0111 21.8698 67.2035 17.494C72.472 16.5 78.7968 16.5 91.4464 16.5C96.9888 16.5 99.7599 16.5 102.423 16.749C113.905 17.8228 124.797 22.3342 133.675 29.694C135.734 31.4011 137.694 33.3607 141.613 37.2797L149.5 45.1667C161.193 56.8595 167.039 62.7059 174.04 66.6011C177.886 68.7409 181.966 70.4307 186.198 71.6371C193.903 73.8333 202.171 73.8333 218.707 73.8333H224.063C261.794 73.8333 280.659 73.8333 292.922 84.8623C294.05 85.8768 295.123 86.9503 296.138 88.0782C307.167 100.341 307.167 119.206 307.167 156.937V188.5C307.167 242.554 307.167 269.582 290.374 286.374C273.582 303.167 246.554 303.167 192.5 303.167H135.167C81.1123 303.167 54.0851 303.167 37.2925 286.374C20.5 269.582 20.5 242.554 20.5 188.5V87.4464Z"  fill-opacity="0.8" shape-rendering="crispEdges"/>
            <path d="M174.04 66.6011L174.283 66.1642L174.04 66.6011ZM186.198 71.6371L186.061 72.118L186.198 71.6371ZM102.423 16.749L102.377 17.2469L102.423 16.749ZM133.675 29.694L133.994 29.3091V29.3091L133.675 29.694ZM296.138 88.0782L296.509 87.7439L296.138 88.0782ZM292.922 84.8623L293.256 84.4906L292.922 84.8623ZM21.494 63.2035L21.0027 63.1108L21.494 63.2035ZM67.2035 17.494L67.1108 17.0027L67.2035 17.494ZM307.167 156.937H306.667V188.5H307.167H307.667V156.937H307.167ZM192.5 303.167V302.667H135.167V303.167V303.667H192.5V303.167ZM20.5 188.5H21V87.4464H20.5H20V188.5H20.5ZM141.613 37.2797L141.26 37.6333L149.146 45.5202L149.5 45.1667L149.854 44.8131L141.967 36.9262L141.613 37.2797ZM218.707 73.8333V74.3333H224.063V73.8333V73.3333H218.707V73.8333ZM149.5 45.1667L149.146 45.5202C160.819 57.1931 166.721 63.101 173.797 67.038L174.04 66.6011L174.283 66.1642C167.358 62.3109 161.566 56.5259 149.854 44.8131L149.5 45.1667ZM218.707 73.8333V73.3333C202.143 73.3333 193.957 73.3289 186.335 71.1563L186.198 71.6371L186.061 72.118C193.849 74.3378 202.2 74.3333 218.707 74.3333V73.8333ZM174.04 66.6011L173.797 67.038C177.677 69.1964 181.792 70.901 186.061 72.118L186.198 71.6371L186.335 71.1563C182.14 69.9603 178.096 68.2853 174.283 66.1642L174.04 66.6011ZM91.4464 16.5V17C96.9981 17 99.742 17.0005 102.377 17.2469L102.423 16.749L102.47 16.2512C99.7779 15.9995 96.9795 16 91.4464 16V16.5ZM141.613 37.2797L141.967 36.9262C138.054 33.0137 136.076 31.0346 133.994 29.3091L133.675 29.694L133.356 30.079C135.393 31.7677 137.334 33.7076 141.26 37.6333L141.613 37.2797ZM102.423 16.749L102.377 17.2469C113.759 18.3112 124.555 22.7833 133.356 30.079L133.675 29.694L133.994 29.3091C125.039 21.8851 114.052 17.3343 102.47 16.2512L102.423 16.749ZM135.167 303.167V302.667C108.125 302.667 87.8946 302.666 72.323 300.572C56.7658 298.48 45.934 294.308 37.6461 286.021L37.2925 286.374L36.939 286.728C45.4436 295.232 56.5217 299.457 72.1898 301.563C87.8435 303.668 108.154 303.667 135.167 303.667V303.167ZM20.5 188.5H20C20 215.513 19.9989 235.823 22.1035 251.477C24.21 267.145 28.4343 278.223 36.939 286.728L37.2925 286.374L37.6461 286.021C29.3582 277.733 25.1862 266.901 23.0946 251.344C21.0011 235.772 21 215.541 21 188.5H20.5ZM307.167 188.5H306.667C306.667 215.541 306.666 235.772 304.572 251.344C302.48 266.901 298.308 277.733 290.021 286.021L290.374 286.374L290.728 286.728C299.232 278.223 303.457 267.145 305.563 251.477C307.668 235.823 307.667 215.513 307.667 188.5H307.167ZM192.5 303.167V303.667C219.513 303.667 239.823 303.668 255.477 301.563C271.145 299.457 282.223 295.232 290.728 286.728L290.374 286.374L290.021 286.021C281.733 294.308 270.901 298.48 255.344 300.572C239.772 302.666 219.541 302.667 192.5 302.667V303.167ZM307.167 156.937H307.667C307.667 138.084 307.668 123.898 306.284 112.895C304.899 101.878 302.12 93.9815 296.509 87.7439L296.138 88.0782L295.766 88.4126C301.185 94.4375 303.92 102.105 305.292 113.019C306.666 123.946 306.667 138.058 306.667 156.937H307.167ZM224.063 73.8333V74.3333C242.942 74.3333 257.054 74.3343 267.981 75.7081C278.895 77.0803 286.563 79.8153 292.587 85.2341L292.922 84.8623L293.256 84.4906C287.018 78.8804 279.122 76.1009 268.105 74.7159C257.102 73.3324 242.916 73.3333 224.063 73.3333V73.8333ZM296.138 88.0782L296.509 87.7439C295.483 86.6028 294.397 85.5169 293.256 84.4906L292.922 84.8623L292.587 85.2341C293.702 86.2368 294.763 87.2978 295.766 88.4126L296.138 88.0782ZM20.5 87.4464H21C21 74.774 21.0022 68.5071 21.9853 63.2962L21.494 63.2035L21.0027 63.1108C19.9978 68.4368 20 74.8195 20 87.4464H20.5ZM91.4464 16.5V16C78.8195 16 72.4368 15.9978 67.1108 17.0027L67.2035 17.494L67.2962 17.9853C72.5071 17.0022 78.774 17 91.4464 17V16.5ZM21.494 63.2035L21.9853 63.2962C26.323 40.3061 44.3061 22.323 67.2962 17.9853L67.2035 17.494L67.1108 17.0027C43.7161 21.4167 25.4167 39.7161 21.0027 63.1108L21.494 63.2035Z" fill="white"/>
            </g>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M167.414 131.168C167.414 125.231 172.227 120.418 178.164 120.418H249.831C255.768 120.418 260.581 125.231 260.581 131.168C260.581 137.105 255.768 141.918 249.831 141.918H178.164C172.227 141.918 167.414 137.105 167.414 131.168Z" fill="#AD9AFF" fill-opacity="0.35"/>
            <defs>
                <filter id="filter0_d_11724_5399" x="0" y="0" width="327.668" height="327.666" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                <feOffset dy="4"/>
                <feGaussianBlur stdDeviation="10"/>
                <feComposite in2="hardAlpha" operator="out"/>
                <feColorMatrix type="matrix" values="0 0 0 0 0.68018 0 0 0 0 0.605556 0 0 0 0 1 0 0 0 1 0"/>
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_11724_5399"/>
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_11724_5399" result="shape"/>
                </filter>
                <linearGradient id="paint0_linear_11724_5399" x1="127.819" y1="-2.49097" x2="168.132" y2="366.772" gradientUnits="userSpaceOnUse">
                <stop stop-color="white"/>
                <stop offset="0.504355" stop-color="#7D64E9"/>
                <stop offset="0.692641" stop-color="#7D64E9"/>
                <stop offset="0.874247" stop-color="#1D077A"/>
                </linearGradient>
            </defs>
           
        </svg>
        <div class="folder-content">

            <div
                class="option-dots"
                v-if="showSettings && folder.id != -1 && showEditOptions(folder) && type=='edit'"
                @click.stop="
                    activeOptionMenu == folder.id
                    ? closeMenus()
                    : activeOptionMenu == -50
                    ? (activeOptionMenu = folder.id)
                    : closeMenus() && (activeOptionMenu = -50)
                "
            >
                <OptionDotsSvg class="themable"/>
            </div>
            <div
                v-if="
                    (showEditOptions(folder)) &&
                    activeOptionMenu == folder.id &&
                    !colorExpanded &&
                    !renameMode
                    && type == 'edit'
                "
                v-click-outside-2="closeMenus"
                class="option-menu"
                :class="{short: (showEditOptions(folder)) && $store.state.user_role != 'admin'}"
                @click.stop
            >
                <div class="color option-block" @click.stop="colorMode(folder)" v-if="(showEditOptions(folder))">
                    <div class="circle"></div>
                </div>
                <div class="group option-block" @click.stop="openGroupSide(folder)" v-if="$store.state.user_role == 'admin' || hasPermission('users.assign_trainings')">
                    <HomeEditOpenGroupSvg class="stroke" />
                </div>
                <div class="gallery option-block" @click.stop="uploadFolderImg(folder)" v-if="(showEditOptions(folder))">
                    <ItemGallerySvg />
                </div>
                <div class="pencil option-block" @click.stop="enterRename(folder)" v-if="(showEditOptions(folder))">
                    <EditFolderNameSvg />
                </div>
                <div class="trash option-block" @click.stop="deleteGroup(folder)" v-if="$store.state.user_role == 'admin'">
                    <GroupFolderTrashSvg />
                </div>
              
            </div>
            <div
                class="option-menu color"
                v-click-outside-2="closeMenus"
                v-else-if="
                    activeOptionMenu == folder.id &&
                    colorExpanded &&
                    !renameMode
                    && type == 'edit'
                "
                @click.stop
            >
                <input
                    class="color-input"
                    :class="[
                    { bright: $store.state.system_settings.color_palette == 0 },
                    { medium: $store.state.system_settings.color_palette == 1 },
                    { blank: $store.state.system_settings.color_palette == 2 },
                    ]"
                    type="range"
                    min="0"
                    max="11"
                    step="0.1"
                    v-model="colorHue"
                    @input.stop="updateColorHue(folder)"
                    @click.stop=""
                    :style="{
                    '--thumb-color': `${
                        folder.color_hue != null
                        ? folder.color_hue
                        : colorPalettes[
                            $store.state.system_settings.color_palette
                            ][0]
                    }`,
                    }"
                />
            </div>
            <div class="content-wrapper">
                <textarea
                    class="folder-name-input"
                    ref="nameInput"
                    v-if="renameMode == true && activeOptionMenu == folder.id"
                    @blur="finishEditing"
                    @input="changeGroupName(folder)"
                    @click.stop=""
                    v-model="groupName"
                    spellcheck="false"
                />
                <span
                    v-else
                    class="folder-name"
                    :class="{
                        darkLetters:
                        folder.id == -1 &&
                        $store.state.system_settings.color_palette == 0,
                    }"
                >
                    {{ folder.name }}
                </span
                >
                <div
                    class="bottom-line"
                    v-if="folder.trainings"
                    :class="[
                        { end: !folder.trainings.length && !folder.trainings },
                        {
                        darkLetters:
                            folder.id == -1 &&
                            $store.state.system_settings.color_palette == 0,
                        },
                    ]"
                >
                  <span class="training-count" v-if="type == 'view' && folder.ended_percent != undefined && folder.trainings.length != 0"
                    >{{ toLocal("groups.finished_trainings") }}
                    {{ folder.ended_percent != null ? folder.ended_percent.toFixed(0) : 0 }} %</span
                  >
                  <span class="training-count" v-else-if="folder.trainings != 0 || Array.isArray(folder.trainings) && folder.trainings.length > 0 "
                      >{{ toLocal("groups.training_count") }}
                      {{ Array.isArray(folder.trainings)  ? folder.trainings.length : folder.trainings }}</span
                  >
                </div>
            </div>
            <!-- <div class="bottom-bar" v-if="type=='view' && folder.ended_percent != undefined">
                <div
                  class="inner-bar"
                  :style="`width: ${folder.ended_percent != null ? folder.ended_percent.toFixed(
                    0
                  ) : 0}%; border-top-right-radius: ${
                    (folder.ended_percent != null && folder.ended_percent.toFixed(0) == 100) ? '0px' : '16px'
                  }`"
                ></div>
              </div> -->
        </div>
    </div>
</template>

<script>
import PlusNarrowSvg from "@/assets/images/icons/plus-narrow-white.svg?inline";
import GroupSearchSvg from "@/assets/images/icons/group-search-black.svg?inline";
import LoadingBubbleSvg from "@/assets/images/icons/loading-bubble.svg?inline";
import ArrowRightFadeSvg from "@/assets/images/icons/arrow-right-fade.svg?inline";
import HomeEditOpenGroupSvg from "@/assets/images/icons/homeEdit/home-edit-group-widthless.svg?inline";
import OptionDotsSvg from "@/assets/images/icons/option-dots.svg?inline";
import EditFolderNameSvg from "@/assets/images/icons/edit-folder-name.svg?inline";
import GroupFolderTrashSvg from "@/assets/images/icons/group-folder-trash.svg?inline";
import VueScrollTo from "vue-scrollto";
import TrainingItemGallerySvg from "@/assets/images/icons/training-item-gallery.svg?inline";
import ItemGallerySvg from "@/assets/images/icons/gallery-img-icon.svg?inline";
import axios from 'axios';
export default {
    props:{
        folder: Object,
        type: {
            type: String,
            default: "edit",
        },
        options: Object,
        rowIndex: Number,
        trainingRowGroups: Array,
        showSettings: Boolean,
    },
    components: {
        OptionDotsSvg,
        EditFolderNameSvg,
        GroupFolderTrashSvg,
        PlusNarrowSvg,
        GroupSearchSvg,
        LoadingBubbleSvg,
        ArrowRightFadeSvg,
        HomeEditOpenGroupSvg,
        TrainingItemGallerySvg,
        ItemGallerySvg
    },
    watch:{
        activeOptionMenu(){
            if(this.activeOptionMenu == -50){
                this.$emit('toggleDrag', false)
            }
            else if(this.renameMode){
                this.$emit('toggleDrag', false)
            }
            else{
                this.$emit('toggleDrag', true)
            }
        }
    },
    data(){
        return{
            deletingStatus: "",
            multiChoiceInfo: {
                type: "multiChoice",
                text: "modal.group_with_trainings",
                undertext: "modal.choose_what_to_do",
                multiChoiceYes: "modal.transfer_to_another",
                multiChoiceNo: "modal.delete_forever",
            },
            multiChoiceOpened: false,
            isFolderCreating: false,
            searchTerm: "",
            isHeaderInView: true,
            colorSliderPos: 0,
            colorHue: 5.5,
            groupName: "",
            addingTraining: false,
            addingNewGroup: false,
            trainingGroupsClone: [],
            trainingGroups: [],
            searchTrainingGroups: [],
            loaded: false,
            selectedTraining: {},
            isSearching: false,
            searchInputValue: "",
            trainingRows: 0,
            activeOptionMenu: -50,
            colorExpanded: false,
            renameMode: false,
            deleteModalOpened: false,
            infoModalOpened: false,
            changedFolders: [],
            selectedView: 1,
            galleryOpen: false,
            colorPalettes: [
                [
                "rgba(230, 69, 69, 1)",
                "rgba(229, 115, 0, 1)",
                "rgba(191, 143, 0, 1)",
                "rgba(100, 153, 46, 1)",
                "rgba(46, 153, 46, 1)",
                "rgba(46, 153, 100, 1)",
                "rgba(46, 153, 153, 1)",
                "rgba(69, 150, 229, 1)",
                "rgba(69, 69, 229, 1)",
                "rgba(150, 69, 230, 1)",
                "rgba(153, 46, 153, 1)",
                "rgba(229, 69, 150, 1)",
                ],
                [
                "rgba(229, 115, 115, 1)",
                "rgba(229, 166, 103, 1)",
                "rgba(229, 229, 103, 1)",
                "rgba(184, 229, 138, 1)",
                "rgba(138, 229, 138, 1)",
                "rgba(115, 229, 172, 1)",
                "rgba(115, 229, 229, 1)",
                "rgba(115, 172, 229, 1)",
                "rgba(138, 138, 229, 1)",
                "rgba(184, 138, 230, 1)",
                "rgba(229, 138, 229, 1)",
                "rgba(229, 138, 184, 1)",
                ],
                [
                "rgba(229, 184, 184, 1)",
                "rgba(229, 207, 184, 1)",
                "rgba(229, 229, 184, 1)",
                "rgba(207, 229, 184, 1)",
                "rgba(184, 229, 184, 1)",
                "rgba(184, 229, 207, 1)",
                "rgba(184, 229, 229, 1)",
                "rgba(184, 207, 229, 1)",
                "rgba(184, 184, 229, 1)",
                "rgba(207, 184, 229, 1)",
                "rgba(229, 184, 229, 1)",
                "rgba(229, 184, 207, 1)",
                ],
            ],
            color1: "rgba(230, 69, 69, 1)",
            color2: "rgba(229, 115, 0, 1)",
            windowWidth: window.innerWidth,
            movingTrainings: false,
            selectedFolder: null,
            selectedMode: 1,
            requestController: null,
            initialFolderHue: '',
            initialFolderName: '',
            dynamicMode: this.$store.state.system_settings.grid_dynamic_size ? this.$store.state.system_settings.grid_dynamic_size  : 0,
        }
    },
 
    methods:{
        getFolderStyle(folder, rowIndex) {
            let style = '';
            if (this.dynamicMode != 0) {
                // style += `grid-column: ${this.trainingRowGroups[rowIndex].length == 1 && this.windowWidth >= 1200
                //     ? '7/'
                //     : this.windowWidth <= 1200 && this.windowWidth > 900
                //       ? ''
                //       : this.windowWidth <= 900 && this.windowWidth > 768 ? '2/' : ''
                //   }span ${folder.columnSize};`
                if(this.options && this.options.minWidth){
                  style += `width: ${this.options.minWidth}%;`;
                }
                else{
                  style += `width: ${folder.columnSize}%;`;
                }
            }else if((rowIndex != undefined) && this.trainingRowGroups){
                style += `grid-column: ${this.trainingRowGroups[rowIndex].length == 1 && this.windowWidth >= 1200
                    ? '7/'
                    : this.windowWidth <= 1200 && this.windowWidth > 900
                    ? ''
                    : this.windowWidth <= 900 && this.windowWidth > 768 ? '' : ''
                }span ${folder.columnSize};`
            }
            else if(this.options && this.options.minWidth){
              style += `width: ${this.options.minWidth}%;`;
            }
           
            try{
                if(folder['data'] && typeof folder['data'] == 'string'){
                folder['data'] = JSON.parse(folder['data'])
                }
            }catch(e){
                console.log(e);
            }
            if(folder['data'] && folder['data']['image']){
                style += `background-image: url(${this.$store.state.api_uploads_link}/${folder['data']['image']});`
                style += `background-color: #ffffff;`
            }else{
                style+=`background-color: ${
                folder.color_hue != null
                    ? folder.color_hue
                    : this.colorPalettes[this.$store.state.system_settings.color_palette]
                    ? this.colorPalettes[this.$store.state.system_settings.color_palette][0]
                    : this.colorPalettes[0][0]
                };`
            }
            if (this.$store.state.system_settings.custom_style && this.$store.state.system_settings.custom_style.training_grid_style) {
                if (this.$store.state.system_settings.custom_style.training_grid_style.color) {
                style += `color: ${this.$store.state.system_settings.custom_style.training_grid_style.color};`
                }
                if (this.$store.state.system_settings.custom_style.training_grid_style['font-weight']) {
                style += `font-weight: ${this.$store.state.system_settings.custom_style.training_grid_style['font-weight']};`
                }
                if (this.$store.state.system_settings.custom_style.training_grid_style['font-size']) {
                style += `font-size: ${this.$store.state.system_settings.custom_style.training_grid_style['font-size']};`
                }
            }
            return style
        },
        openGroup(id) {
            this.$emit('openGroup', id)
        },
        showEditOptions(folder) {
            if (this.$store.state.user_role == 'admin') return true;
            else if (this.$store.state.user_permissions
                && this.$store.state.user_permissions['trainings.edit_in_groups']
                && this.$store.state.user_permissions['trainings.edit_in_groups'].items
                && this.$store.state.user_permissions['trainings.edit_in_groups'].items.includes(folder.id)) {
                return true;
            }
            else if(folder.created_by == this.$store.state.user_id) return true;
            else {
                return false;
            }
        },
        closeMenus() {
            setTimeout(() => {
                if (this.activeOptionMenu != -50) {
                   
                    this.colorExpanded = false;
                    this.activeOptionMenu = -50;
                    this.groupName = "";
                    this.renameMode = false;
                    
                    this.saveGroupFolder(this);
                }
            }, 200);
        },
/*************  ✨ Windsurf Command ⭐  *************/
/**
 * Activates the color mode for a folder, expanding the color options.
 * Initializes the color hue based on the folder's current color settings.
 * If the folder has no color hue, sets the default hue to 0.
 * If the folder has a color slider position, uses it to set the color hue.
 *
 * @param {Object} folder - The folder object containing color properties.
 */

/*******  09451f60-aef3-4830-87d6-6ada0ab46754  *******/
        colorMode(folder) {
            this.initialFolderHue = this._.cloneDeep(folder.color_hue);
            this.colorExpanded = true;
            if (folder.color_hue == null) {
                this.colorHue = 0;
            } else {
                if (folder.color_slider_pos != null) {
                this.colorHue = folder.color_slider_pos;
                }
            }
        },
        openGroupSide(folder){
            this.$emit("openGroupSide", folder);
           
        },
        uploadFolderImg(folder){
            this.$emit("uploadFolderImg", folder);
       
        },
        enterRename(folder) {
            this.initialFolderName = this._.cloneDeep(folder.name);
            this.groupName = "";
            this.groupName = folder.name;
            this.renameMode = true;
            this.$nextTick(() => this.$refs.nameInput.focus());
        },
        deleteGroup(folder) {
            this.$emit("deleteGroup", folder);
        },
        updateColorHue(folder) {
            window.requestAnimationFrame(() => {
                this.changeGroupHue(folder);
            });
            if(this.activeOptionMenu != -50){
                this.saveGroupFolder(this);
            }
        },
        saveGroupFolder: _.debounce((self)=>{
            let folder = self.folder;
            if (
                folder.name === self.initialFolderName &&
                folder.color_hue === self.initialFolderHue
            ) {
                return;
            } 
            else {
                axios
                .post(
                    `${self.$store.state.api_link}/training_group/editInfo/${folder.id}`,
                    {
                    name: folder.name,
                    color_pos: folder.color_hue != self.initialFolderHue ? self.colorHue : null,
                    },
                    self.$store.getters.axiosConfig()
                )
                .then((response) => {
                })
                .catch((error) => {
                    self.$store.commit("handleError", { error: error });
                });
            }
        }, 500),
        changeGroupHue(folder, optionalColor) {
            if (optionalColor != undefined) {
                this.colorHue = optionalColor;
            }
            let colorGroup = Math.floor(
                this.colorHue %
                this.colorPalettes[this.$store.state.system_settings.color_palette]
                    .length
            );
            this.color1 =
                this.colorPalettes[this.$store.state.system_settings.color_palette][
                colorGroup
                ];
            if (
                this.colorPalettes[this.$store.state.system_settings.color_palette][
                colorGroup + 1
                ] == undefined
            ) {
                this.color2 ==
                this.colorPalettes[this.$store.state.system_settings.color_palette][
                    this.colorPalettes[this.$store.state.system_settings.color_palette]
                    .length - 1
                ];
            } else {
                this.color2 =
                this.colorPalettes[this.$store.state.system_settings.color_palette][
                    colorGroup + 1
                ];
            }
            // this.colorHue /= 100;
            let color1Values = this.color1
                .replace("rgba(", "")
                .replace(")", "")
                .split(",");
            let color2Values = this.color2
                .replace("rgba(", "")
                .replace(")", "")
                .split(",");
            let copiedColor = this.colorHue;
            for (let i = 1; i <= copiedColor; ) {
                copiedColor -= 1;
            }
            let midwayValues = color1Values.map(
                (val, index) =>
                (1 - copiedColor) * parseInt(val) +
                copiedColor * parseInt(color2Values[index])
            );
            midwayValues[midwayValues.length - 1] = 1;
            let color = `rgba(${midwayValues
                .map((val) => Math.floor(val))
                .join(",")})`;
            if(!folder.color_hue){
                folder.color_hue = color;
                
            }
            if(folder.color_hue && !folder.color_hue.startsWith('#'))
                folder.color_hue = color;
        },
        changeGroupName(folder) {
            this.$set(folder, "name", this.groupName);
        },
        finishEditing() {
            this.closeMenus();
        },
    }
}
</script>

<style lang="scss" scoped>
.folder-block {
    min-height: 300px;
    min-width: 300px;
    max-width: 100%;
    // background-color: rgb(97, 3, 3);
    // box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
    border-radius: 16px;
    position: relative;
    transition: 0.2s;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    transition: transform 0.3s ease;
    
    // background: linear-gradient(173.77deg, rgba(255, 255, 255, 0.8) -2.29%, rgba(125, 100, 233, 0.8) 56.98%, rgba(125, 100, 233, 0.8) 79.11%, rgba(29, 7, 122, 0.8) 100.45%);
    // -webkit-clip-path: url(#folderShape);
    // clip-path: url(#folderShape);
    &:hover{
        transform: rotate3d(1, 1, 1, 3deg);
    }

  &.bright {
    color: white;
    svg {
      &.themable{
        stroke: white;
      g {
        fill: white;
      }
      path {
        stroke: white;
      }
      }
    }
  }
  &.medium {
    color: #333333;
    color: #333333;
    svg {
      &.themable{
      g {
        fill: #333333;
      }
      path {
        stroke: #333333;
      }
      }
    }
  }
  &.blank {
    color: #333333;
    svg {
      &.themable{
      g {
        fill: #333333;
      }
      path {
        stroke: #333333;
      }
    }
    }
  }
  &.colors-open{
    &:hover {
    .folder-block-cover{
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      transition: 0.25s;
      background-color: initial;
      border-radius: 16px;
    }
    .bottom-line {
      .arrow-container {
        svg {
          opacity: 1;
        }
      }
    }
  }
  }
  @media (max-width: 421px) {
      min-width: 100%;
    min-height: 250px;
  }
  cursor: pointer;
  &:hover {
    .folder-block-cover{
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      transition: 0.25s;
      background-color: rgba($color: #000000, $alpha: 0.1);
      border-radius: 16px;
    }
    .bottom-line {
      .arrow-container {
        svg {
          opacity: 1;
        }
      }
    }
  }
}
.bottom-line {
  display: flex;
  width: 100%;
  justify-content: space-between;
  z-index: 1;
  cursor: pointer;
  .end{
    justify-content: flex-end;
  }
  .arrow-container {
    padding: 10px 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    border-radius: 50%;
    justify-self: flex-end;
    svg {
      opacity: 0.5;
      transition: 0.5s;
    }
    &:hover {
      // background-color: hsla(0, 0%, 100%, 0.199);
      svg {
        opacity: 1;
      }
    }
  }
  &.end {
    justify-content: flex-end;
  }
}
.folder-content{
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    padding: 1.75rem 1rem;
}
.content-wrapper{
    display: flex;
    flex-direction: column;
    padding: 35px 38px;
    gap: 8px;
}
.folder-name {
    font-size: 20px;
    font-weight: bold;
    font-family: 'Poppins', var(--main-site-font);
 
}
.folder-name-input {
    width: 70%;
    height: 70%;
    top: 24px;
    left: 24px;
    font-size: 20px;
    font-weight: bold;
    font-family: 'Poppins', var(--main-site-font);
    word-wrap: break-word;
    background-color: transparent;
    color: white;
    border: none;
    resize: none;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    text-decoration: underline;
    font-family: var(--main-site-font);
    &:focus {
        outline: none;
    }
}
.bottom-bar {
  width: 100%;
  position: absolute;
  bottom: 0;
  min-height: 20px;
  border-bottom-right-radius: 16px;
  .inner-bar {
    min-height: 20px;
    border-bottom-left-radius: 16px;
    border-top-right-radius: 16px;
    border-bottom-right-radius: 16px;
    background: rgba(255, 255, 255, 0.2);
  }
}
.option-dots {
  position: absolute;
  top: 20px;
  right: 16px;
  height: 42px;
  width: 48px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 10px;
  border-radius: 20px;
  transition: 0.5s;
  svg {
    width: 100%;
    height: 100%;
    overflow: visible;
    g {
      opacity: 0.5;
      transition: 0.5s;
    }
  }
  &:hover {
    svg {
      g {
        opacity: 1;
      }
    }
  }
}
.training-count {
  font-size: 16px;
  display: flex;
  align-items: center;
}
.option-menu {
  z-index: 2;
  position: absolute;
  right: 18px;
  top: 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 48px;
  max-height: 100%;
  color: black;
  background-color: rgba(249, 249, 249, 1);
  transform-origin: top;
  animation: expand 0.5s;
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.16);
  border-radius: 4px;
    overflow: hidden;
  &.color {
    height: 80%;
    justify-content: center;
  }
  &.short{
    height: fit-content;
    animation: none;
  }
  .color-input {
    &.bright {
      background: linear-gradient(
        90deg,
        #e64545 0%,
        #e57300 10.33%,
        #b28500 19.44%,
        #64992e 28.3%,
        #2e992e 37.29%,
        #2e9964 45.88%,
        #2e9999 54.61%,
        #4596e5 63.72%,
        #4545e5 72.45%,
        #9645e6 81.95%,
        #992e99 91.2%,
        #e54596 100%
      );
    }
    &.medium {
      background: linear-gradient(
        90deg,
        #e57373 0%,
        #e5a667 10.33%,
        #e5e567 19.44%,
        #b8e58a 28.3%,
        #8ae58a 37.29%,
        #73e5ac 45.88%,
        #73e5e5 54.61%,
        #72ace5 63.72%,
        #8a8ae5 72.45%,
        #b88ae6 81.95%,
        #e58ae5 91.2%,
        #e58ab8 100%
      );
    }
    &.blank {
      background: linear-gradient(
        90deg,
        #e5b8b8 0%,
        #e5cfb8 10.33%,
        #e5e5b8 19.44%,
        #cfe5b8 28.3%,
        #b8e5b8 37.29%,
        #b8e5cf 45.88%,
        #b8e5e5 54.61%,
        #b8cfe5 63.72%,
        #b8b8e5 72.45%,
        #cfb8e5 81.95%,
        #e5b8e5 91.2%,
        #e5b8cf 100%
      );
    }
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.16);
    border-radius: 10px;
    width: 209px;
    max-height: 12px;
    -webkit-transform: rotate(90deg);
    // max-width: 12px;
    -webkit-appearance: none;
    cursor: pointer;
    &::-webkit-slider-runnable-track {
      width: 209px;
      max-width: 209px;
      height: 12px;
      // transform: r;
      // -webkit-transform: rotate(90deg);
    }
    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      box-sizing: border-box;
      margin-top: -6px;
      border: 3px solid #f9f9f9;
      box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.16);
      background-color: var(--thumb-color);
    }
    &::-moz-range-thumb {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      box-sizing: border-box;
      margin-top: -6px;

      border: 3px solid #f9f9f9;
      box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.16);
      background-color: var(--thumb-color);
    }
  }
  .option-block {
    width: 100%;
    min-height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    &.group{
      svg{
        width: 50%;
      }
    }
    &.gallery{
      svg{
        width: 70%;
      }
    }
    &:hover {
      background-color: #d9d9d9;
      &.group{
        svg path{
          fill: white;
        }
      }
    }
    &.color {
      .circle {
        width: 29px;
        background: conic-gradient(
          at 50% 50%,
          red,
          #ff0 16.66%,
          #0f0 33.33%,
          #0ff 50%,
          #00f 66.66%,
          #f0f 83.33%,
          red
        );
        height: 29px;
        border-radius: 50%;
      }
    }
  }
}
@keyframes expand {
  from {
    max-height: 0%;
  }
  to {
    max-height: 100%;
  }
}
</style>